import * as yup from 'yup';

export function validateSwedishPostalCode(isRequired = false) {
  const base = yup
    .string()
    .nullable()
    .trim('Postnummer bör inte innehålla runt det')
    .matches(/^[\d ]+$/, 'Postnummer får endast innehålla siffror');

  if (isRequired) {
    return base.length(6, 'Postnummer måste vara exakt fem siffror långt\n');
  }

  return base;
}
